import { useEffect, useMemo } from 'react';
import { Callback } from '@/pages';
import history from '@/settings/history';
import { preserveUrl } from '@/utils/preserveUrl';
import { AuthGateProps } from './types';
import { shouldAuthenticate } from './utils';

const AuthGate = ({ auth, children }: AuthGateProps) => {
  const isAuthCallback = useMemo(() => shouldAuthenticate(window.location), [window.location]);

  /* ---------------- Handle Auth Callback ---------------- */

  useEffect(() => {
    if (isAuthCallback) auth.handleAuthentication();
  }, [auth, isAuthCallback]);

  /* ---------------- Redirect If Not Authenticated ---------------- */

  useEffect(() => {
    if (isAuthCallback) return;

    if (!auth.isAuthenticated()) history.replace('/login', { replace: true });
  }, [auth, history.replace, isAuthCallback]);

  /* ---------------- Preserve URL ---------------- */

  useEffect(() => {
    const unlisten = history.listen(() => preserveUrl(window.location.pathname, window.location.search));

    return () => unlisten?.();
  }, []);

  if (isAuthCallback) return <Callback />;

  return <>{children}</>;
};

export default AuthGate;
